/*
 * Copyright 2020 Spotify AB
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */

import dayjs from "dayjs";
import durationPlugin from "dayjs/plugin/duration";
import relativeTimePlugin from "dayjs/plugin/relativeTime";

dayjs.extend(durationPlugin);
dayjs.extend(relativeTimePlugin);

type DateTimeObject = Date | string | number | undefined;

export function relativeTimeTo(time: DateTimeObject, withoutSuffix = false) {
  return dayjs().to(dayjs(time), withoutSuffix);
}

export function durationHumanized(
  startTime: DateTimeObject,
  endTime: DateTimeObject
) {
  return dayjs.duration(dayjs(startTime).diff(dayjs(endTime))).humanize();
}
